import React from "react";
import { useModalState } from "../../helpers/ModalProvider";
import { useDisconnect } from "wagmi";
import { Stack, Text } from "@chakra-ui/react";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

export const CannotConnectWalletModal: React.FC = () => {
  const { disconnect } = useDisconnect();
  // Access the modal state from our provider:
  const { isCannotConnectWalletModalVisible, closeCannotConnectWalletModal } =
    useModalState();

  const handleClose = () => {
    disconnect();
    closeCannotConnectWalletModal();
  };

  return (
    <DialogRoot
      lazyMount
      open={isCannotConnectWalletModalVisible}
      onOpenChange={(e) => {
        if (!e.open) handleClose();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cannot Connect Wallet</DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          <Stack gap={4}>
            <Text>
              We could not connect this wallet to your account. This could be
              because it is not the correct type of wallet, or this wallet is
              already associated with another account.
            </Text>
            <Text>
              Please try another wallet or disconnect this wallet from any
              existing accounts before connecting to this one.
            </Text>
          </Stack>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
